import "./../../../bindings/bao-pager";
import "./../../../bindings/foreach-selection";
import baoRouter from "./../../../services/bao-router";
import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
class CurrentTasksModule {
    private _parent: any;
    private CurrentTasks: KnockoutObservableArray<any>;
    private PageSize: KnockoutObservable<number>;
    private PageIndex: KnockoutObservable<number>;
    private Sorting: KnockoutObservableArray<any>;
    private Initialized: KnockoutObservable<boolean>;
    private SelectedRow: KnockoutObservable<any>;
    private TotalRows: KnockoutObservable<number>;
    constructor(parent) {
        this._parent = parent;
        this.PageSize = ko.observable(20);
        this.PageIndex = ko.observable(0);
        this.Sorting = ko.observableArray();
        this.Initialized = ko.observable(false);
        this.SelectedRow = ko.observable({});
        this.TotalRows = ko.observable(0);
        this.CurrentTasks = ko.observableArray([]);
        this.PageIndex.subscribe(() => {
            this.Load();
        });
        this.PageSize.subscribe(() => {
            this.PageIndex(0);
            this.Load();
        });
        this.Sorting.subscribe(() => {
            this.Load();
        });
        parent.Refresh = () => {
            var def = $.Deferred();
            this.Refresh().then(() => { def.resolve(); });
            return def.promise();                                 
        };
        Bao.bindEvent('checkware-tasks:refresh', () => {
            this.Refresh();
        });
    }
    Load() {
        this._parent.TabPage.IsLoading(true);
        var def = $.Deferred();
        if (this.Initialized()) {
            Bao.post("Module/GetTasksOfCurrentUser", JSON.stringify({
                pageIndex: this.PageIndex(),
                pageSize: this.PageSize(),
                sorting: this.Sorting()
            }), (searchResult) => {
                this.SelectedRow({});
                this.TotalRows(0);
                this.CurrentTasks([]);
                if (searchResult != null && searchResult.Models != null) {
                    this.CurrentTasks(searchResult.Models);
                    this.TotalRows(searchResult.TotalRows);
                }
                def.resolve();
                this._parent.TabPage.IsLoading(false);
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    Refresh = () => {
        return this.Load();
    };
    init() {
        this.Initialized(true);
        return $.Deferred<void>().resolve().promise();
    }
    ;
    loaded() {
        return this.Load();
    }
    ;
}
export default CurrentTasksModule;